/**
 * Shared visualization helpers for B2B fit-analysis verdicts.
 *
 * The 5 verdict values come from agent #1 in the backend
 * (app/services/b2b_ai_prompts.py VERDICT_RUBRIC).
 */

export const FIT_VERDICTS = {
  ideal: {
    label: 'Ideal',
    short: 'Ideal',
    description: 'Hits every must-have, brings adjacent strengths.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    dotClass: 'bg-emerald-500',
    rank: 5,
  },
  good_fit: {
    label: 'Good fit',
    short: 'Good',
    description: 'Meets all must-haves, minor gaps in nice-to-haves.',
    badgeClass: 'bg-lime-50 text-lime-700 border-lime-200',
    dotClass: 'bg-lime-500',
    rank: 4,
  },
  average: {
    label: 'Average',
    short: 'Avg',
    description: 'Mixed match — real risks the recruiter must probe.',
    badgeClass: 'bg-amber-50 text-amber-700 border-amber-200',
    dotClass: 'bg-amber-500',
    rank: 3,
  },
  weak: {
    label: 'Weak',
    short: 'Weak',
    description: 'Significant gaps in core requirements.',
    badgeClass: 'bg-orange-50 text-orange-700 border-orange-200',
    dotClass: 'bg-orange-500',
    rank: 2,
  },
  no_fit: {
    label: 'No fit',
    short: 'No fit',
    description: 'Misses 2+ must-haves or wrong career level.',
    badgeClass: 'bg-red-50 text-red-700 border-red-200',
    dotClass: 'bg-red-500',
    rank: 1,
  },
}

export function getFitMeta(verdict) {
  if (!verdict) return null
  return FIT_VERDICTS[String(verdict).toLowerCase()] || null
}

/**
 * 8 BARS scale labels, matching app/services/interview_ai_prompts.py
 * BARS_SCALE_NAMES + frontend src/components/interview/CompetencyAnalysis.jsx
 * ALL_SCALES.
 */
export const BARS_SCALE_LABELS = {
  1: { name: 'Analytical Thinking', icon: '🧩' },
  2: { name: 'Communication', icon: '💬' },
  3: { name: 'Adaptability', icon: '🔄' },
  4: { name: 'Ownership', icon: '🎯' },
  5: { name: 'Teamwork', icon: '🤝' },
  6: { name: 'Motivation', icon: '🚀' },
  7: { name: 'Self-Awareness', icon: '🪞' },
  8: { name: 'Domain Expertise', icon: '⚡' },
}

export function barsLevelLabel(score) {
  if (score >= 5) return 'Top specialist level'
  if (score >= 4) return 'Strong level'
  if (score >= 3) return 'Solid baseline'
  if (score >= 2) return 'Needs work'
  return 'Critical gap'
}
